import styles from "@css/modules/ResortSections.module.scss"
import { Gallery } from "./Gallery"
import { Clock, ForkKnife } from "@css/icons/SVG"
import { useMediaQuery } from "@utils/hooks/useMediaQuery"
import Image from "next/image"

export function DiningLocationItem({ title, subTitle, description, tags = "", gallery, menuURL, availabilityURL }) {
    const readyTags = tags ? tags.split(",") : []
    const isMobile = useMediaQuery("(max-width: 1023px)")

    const buttons = (
        <div className={styles.overAction}>
            {menuURL && (
                <a target="_blank" rel="noopener noreferrer" href={menuURL} className={styles.menuBtn}>
                    <ForkKnife /> View Menu{" "}
                </a>
            )}
            {availabilityURL && (
                <a target="_blank" rel="noopener noreferrer" href={availabilityURL} className={styles.availabilityBtn}>
                    <Clock />
                    Check Availability
                </a>
            )}
        </div>
    )
    if (isMobile) {
        const img = gallery[0]
        const imgUrl = img?.url
        return (
            <div className={styles.diningLocationItemMobile}>
                {img && <Image loading="lazy" src={imgUrl} alt={title} className={styles.mobileImg} width={img.width} height={img.height} />}
                <div className={styles.content}>
                    <div className={styles.title}>{title}</div>
                    <div className={styles.subTitle}>{subTitle}</div>
                    <div className={styles.description}>{description}</div>
                    <div className={styles.overTags}>
                        {readyTags.map((i, index) => (
                            <div className={styles.tag} key={index}>
                                {i}
                            </div>
                        ))}
                    </div>
                    {buttons}
                </div>
            </div>
        )
    }
    return (
        <div className={styles.diningLocationItem}>
            <div className={styles.left}>
                <div className={styles.title}>{title}</div>
                <div className={styles.subTitle}>{subTitle}</div>
                <div className={styles.description}>{description}</div>
                <div className={styles.overTags}>
                    {readyTags.map((i, index) => (
                        <div className={styles.tag} key={index}>
                            {i}
                        </div>
                    ))}
                </div>
            </div>
            <div className={styles.right}>
                <Gallery items={gallery} />
                {buttons}
            </div>
        </div>
    )
}
